import BaseComponent from "../../../../core/infraestructure/BaseComponent";
import DashboardViewModel from '../../../../core/features/home/viewmodels/DashboardViewModel';

export default {
    extends: BaseComponent,
    data() {
        return {
            viewModel: null,
            formProcessingMessage: "",
            isFormProcessing: false,
            isRefreshing: false,
            currentCourseStats: null,
            currentUserStats: null,
            formData: {
                email: ''
            },
            rules: {}
        };
    },
    created() {
        this.viewModel = new DashboardViewModel(this);
        this.onActive();
    },
    methods: {
        onActive() {
            this.viewModel.bindStats();
        },
        onRefresh() {
            this.isRefreshing = true;
            this.viewModel.bindStats();
            setTimeout(() => {
                this.isRefreshing = false;
            }, 600);
        },
        findCourseStatsResponse(response) {
            this.currentCourseStats = (response && response.data !== undefined) ? response.data : response;
        },
        findUserStatsResponse(response) {
            this.currentUserStats = (response && response.data !== undefined) ? response.data : response;
        }
    },
    computed: {
        totalUsers() {
            if (!this.currentUserStats) return 0;
            return (Number(this.currentUserStats.totalUsersActive) || 0) + (Number(this.currentUserStats.totalUsersInactive) || 0);
        },
        activeUsersPercentage() {
            if (!this.totalUsers) return 0;
            return Math.round(((Number(this.currentUserStats?.totalUsersActive) || 0) / this.totalUsers) * 100);
        },
        activeSubsPercentage() {
            const total = Number(this.currentUserStats?.totalSubscriptions) || 0;
            if (!total) return 0;
            const active = Number(this.currentUserStats?.totalSubscriptionsActive) || 0;
            return Math.round((active / total) * 100);
        },
        totalReactions() {
            if (!this.currentCourseStats) return 0;
            return (Number(this.currentCourseStats.totalLiked) || 0) + (Number(this.currentCourseStats.totalDisliked) || 0);
        },
        likedPercentage() {
            if (!this.totalReactions) return 0;
            return Math.round(((Number(this.currentCourseStats?.totalLiked) || 0) / this.totalReactions) * 100);
        }
    }
};
